<script setup lang="ts">
import { computed } from 'vue';
import PlaylistWithBucketLink from '@/components/DataTable/PlaylistWithBucketLink.vue';

/**
 * The player inspector's "Current Playlist" value.
 *
 * A check-in reports a filename, so the row used to read
 * "0000000000000000000024071003--41819.txt" — accurate, and useless unless you
 * know 41819 is a playlist id. {@link PlaylistWithBucketLink} shows the real
 * name and opens it, and gives a bucket-backed list two separate links so the
 * bucket is one click away rather than two. The same component draws the
 * playlist line on the player card, so the two cannot disagree.
 */
const props = defineProps<{ row: Record<string, unknown> }>();

const playlistName = computed(() => {
    const name = props.row.player_data_current_playlist_name;
    return typeof name === 'string' && name.trim() !== '' ? name.trim() : null;
});

const locationZonePlayerId = computed(() => (typeof props.row.id === 'number' ? props.row.id : null));
</script>

<template>
    <PlaylistWithBucketLink
        v-if="playlistName"
        :playlist-name="playlistName"
        :location-zone-player-id="locationZonePlayerId"
    />
    <span v-else class="text-muted-foreground">—</span>
</template>
